module.exports = __webpack_public_path__ + "img/3.7b72300a.gif";